const CustomSortDirective = function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {
            order: '=',
            sort: '=',
            nosort: '@?'
        },
        template:
            '<a href ng-click="sort_by(order)">' +
            '<span ng-transclude></span>' +
            '<sub class="material-icons tight" ng-bind="selectedCls(order)"></sub>' +
            '</a>&nbsp;',
        link: function (scope) {

            // change sorting order
            scope.sort_by = function (newSortingOrder) {
                if (!scope.nosort) {
                    var sort = scope.sort;

                    if (sort.sortingOrder == newSortingOrder) {
                        sort.reverse = !sort.reverse;
                    } else {
                        sort.reverse = false;
                    }

                    sort.sortingOrder = newSortingOrder;

                    scope.$emit("sortChanged", sort);
                }
            };


            scope.selectedCls = function (column) {
                if (scope.sort && column == scope.sort.sortingOrder) {
                    return 'arrow_drop_' + (scope.sort.reverse ? 'down' : 'up')
                }
                else {
                    return ''
                }
            };
        }// end link
    }
};

export { CustomSortDirective };